import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { NativeCommandEnum } from '~/domain/native/models/commands';
import { dispatchNativeCommand } from '~/domain/native/store/reducer';

const useAnalyticsNative = () => {
  const dispatch = useDispatch();
  const setUserIdThroughNative = useCallback(
    (userId: string) => {
      dispatch(
        dispatchNativeCommand({
          name: NativeCommandEnum.AnalyticsSetUserId,
          params: { userId },
        })
      );
    },
    [dispatch]
  );
  const logEventThroughNative = useCallback(
    (eventName: string, parameters?: { [key: string]: unknown }) => {
      dispatch(
        dispatchNativeCommand({
          name: NativeCommandEnum.AnalyticsLogEvent,
          params: { eventName, parameters },
        })
      );
    },
    [dispatch]
  );
  const setUserPropsThroughNative = useCallback(
    (name: string, value: string) => {
      dispatch(
        dispatchNativeCommand({
          name: NativeCommandEnum.AnalyticsSetUserProperty,
          params: { name, value },
        })
      );
    },
    [dispatch]
  );

  return { setUserIdThroughNative, logEventThroughNative, setUserPropsThroughNative };
};
export { useAnalyticsNative };
